import UrlGeneration from "../libs/UrlGeneration";

export default new (class {
    constructor() {
        this.initHandler()
    }

    /**
     * @description Init handler.
     */
    initHandler() {
        document.addEventListener("DOMContentLoaded", () => {
            document.querySelector('.category-brand-filter').addEventListener('change', (e) => {
                const filterWrap = e.currentTarget;
                const itemsWrap = document.querySelector('#category-brand-items');
                itemsWrap.classList.add('_preloader')
                filterWrap.classList.add('_preloader');
                let value = e.target.value;

                const data = {
                    'subcategory' : value
                };

                if (value == 'reset') {
                    delete data.subcategory;
                }

                oc.ajax("BrandList::onAjaxRequest", {
                    update: {
                        // 'pagination/pagination-items': `#pagination-items-article-list`,
                        'catalog-page/category-brand-items': `#category-brand-items`
                    },
                    data,
                    complete: () => {
                        itemsWrap.classList.remove('_preloader');
                        filterWrap.classList.remove('_preloader')
                    }
                });
            })
        });
    }
})()
